export interface LanguageProps {
  languageId: string;
  locale: string;
  name: string;
  icon: string;
}

export const languageData: LanguageProps[] = [
  {
    languageId: 'french',
    locale: 'fr-FR',
    name: 'Français',
    icon: 'fr',
  },
  {
    languageId: 'english',
    locale: 'en-US',
    name: 'English',
    icon: 'us',
  },
  {
    languageId: 'spanish',
    locale: 'es-ES',
    name: 'Español',
    icon: 'es',
  },
];
export default languageData;
